import { useQuery, gql } from "@apollo/client";
import type { ApolloQueryResult } from "@apollo/client";
import type { Blog, PaginatedBlogResponse } from "../types/models";

export interface MyBlogsByPageData {
  myBlogsByPage: PaginatedBlogResponse;
}

export interface MyBlogsByPageVariables {
  page?: number;
  pageSize?: number;
}

export const GET_MY_BLOGS_BY_PAGE = gql`
  query MyBlogsByPage($page: Int, $pageSize: Int) {
    myBlogsByPage(page: $page, pageSize: $pageSize) {
      blogs {
        id
        title
        description
        imgUrl
        category
        timestamp
        author
        views
        likeCount
      }
      currentPage
      totalPages
    }
  }
`;

type RefetchFn = (
  variables?: MyBlogsByPageVariables
) => Promise<ApolloQueryResult<MyBlogsByPageData>>;

export const useMyPaginatedBlogs = (
  page = 1,
  pageSize = 6,
  skip = false
) => {
  const { data, loading, error, refetch } = useQuery<
    MyBlogsByPageData,
    MyBlogsByPageVariables
  >(GET_MY_BLOGS_BY_PAGE, {
    variables: { page, pageSize },
    skip, // Skip query if skip is true
    fetchPolicy: "cache-first", // Use cache-first to prevent unnecessary calls
    nextFetchPolicy: "cache-first",
  });

  return {
    blogs: (data?.myBlogsByPage.blogs as Blog[]) || [],
    currentPage: data?.myBlogsByPage.currentPage || 1,
    totalPages: data?.myBlogsByPage.totalPages || 1,
    isLoading: loading,
    error,
    refetchPage: refetch as RefetchFn,
  };
};
